import styled from '@emotion/styled/macro';
import { Variables, MetricsValue } from '@enter/core';

export const Wrapper = styled.div`
    padding: 24px 48px 48px 48px;
`;

export const Content = styled.div`
    color: ${Variables.Colors.n50};
`;

export const LoadingContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    padding: ${MetricsValue.Regular2xl}px;
    justify-content: center;
    align-items: center;
`;

